<template>
  <div class="text-block big-card-block block-card card-border card-appointment ">
    <v-expansion-panel
        :value="panel"
        expand>
      <v-expansion-panel-content :lazy="lazyRendering">
        <template v-slot:header >
          <div class="block-card-title handle" >
            <div class="title-icon">
              <v-icon class="white--text text-lg-2">date_range</v-icon>
            </div>

            <h4>
              Book Appointment
              <v-icon
                  v-if = "errorsCount && errorsCount.errorsCount"
                  color = "error"
                  style = "margin-left: 4px;">error</v-icon>
            </h4>
          </div>
        </template>
        <form-validation v-model = "errorsCount">
          <div class="card-inner-wrapper">


            <label for="">Card Title</label>
            <vTextareaAutocomplete
                v-model="data.extensionTitle"
                :type="'textfield'"
                :validation-rules=" [v => !!v || 'Title is Required']"
                :counter="1000"
            />


            <label for="">Card Message</label>
            <vTextareaAutocomplete
                v-model="data.extensionMessage"
                :type="'textarea'"
                :validation-rules=" [v => !!v || 'Message is Required']"
                :counter="1000"
            />

            <label for="">Card Button Label</label>
            <vTextareaAutocomplete
                v-model="data.buttonTitle"
                :type="'textfield'"
                :validation-rules=" [v => !!v || 'Button label is Required']"
                :counter="20"
            />


            <label ><span class="text-bold">Or</span> Upload Your Image</label>
            <image-input
                :url="data.extensionImage"
                @onImageUpload="updateImageUrl"/>



            <label for="">Next Button Label</label>
            <vTextareaAutocomplete
                v-model="data.nextButtonLabel"
                :type="'textfield'"
                :validation-rules=" [v => !!v || 'Label is Required']"
                :counter="1000"
            />

            <label for="">Booking Button Label</label>
            <vTextareaAutocomplete
                v-model="data.bookingButtonLabel"
                :type="'textfield'"
                :validation-rules=" [v => !!v || 'Label is Required']"
                :counter="1000"
            />

            <!-- <label for="">Successful redirect block</label>
            <v-autocomplete
                :items="blocksList"
                v-model="data.successfulBlockRedirect"
                :error="!data.successfulBlockRedirect"
                :error-messages="!data.successfulBlockRedirect? 'Please select at least one block':'' "
                item-text="name"
                item-value="id"
                outline
                solo
                chips
            /> -->


            <label for="">Cancel button label</label>
            <vTextareaAutocomplete
                v-model="data.cancelButtonLabel"
                :type="'textfield'"
                :validation-rules=" [v => !!v || 'Cancel button label is Required']"
                :counter="1000"
            />

            <label for="">Cancel redirect block</label>
            <v-autocomplete
                :items="blocksList"
                v-model="data.cancelRedirectBlock"
                :error="!data.cancelRedirectBlock"
                :error-messages="!data.cancelRedirectBlock? 'Please select at least one block':'' "
                item-text="name"
                item-value="id"
                outline
                solo
                chips
            />

            <label for="">Error message</label>
            <vTextareaAutocomplete
                v-model="data.errorMessage"
                :type="'textarea'"
                :validation-rules=" [v => !!v || 'Error message is Required']"
                :counter="1000"
            />


          </div>


            <div class="button-list mt-4">
              <v-tabs centered grow color="#F4F5F9" v-model="activeTab" style="min-height: 1000px; height: auto;">
                <v-tab>
                  Step 1
                </v-tab>
                <v-tab>
                  Step 2
                </v-tab>
                <v-tab>
                  Step 3
                </v-tab>
                <v-tab-item class="mt-3">
                  <div class="block-card-body">
                    <label for="">Step name</label>
                    <vTextareaAutocomplete
                        v-model="data.step1.name"
                        :type="'textfield'"
                        :validation-rules=" [v => !!v || 'Name is Required']"
                        :counter="1000"
                    />

                    <label for="">Step icon</label>
                    <image-input  :small="true" :url="data.step1.icon" @onImageUpload="data.step1.icon = $event " :validation="false" ></image-input>

                    <label for="">Step title</label>
                    <vTextareaAutocomplete
                        v-model="data.step1.title"
                        :type="'textfield'"
                        :validation-rules=" [v => !!v || 'Title is Required']"
                        :counter="1000"
                    />



                    <label for="">Save selected id to attribute</label>
                    <vTextareaAutocomplete
                        v-model="data.step1.selectedIdAttribute"
                        :type="'textfield'"
                        :validation-rules=" [v => !!v || 'Attribute is Required']"
                        :counter="1000"
                    />

                    <label for="">Save selected name to attribute</label>
                    <vTextareaAutocomplete
                        v-model="data.step1.selectedNameAttribute"
                        :type="'textfield'"
                        :validation-rules=" [v => !!v || 'Attribute is Required']"
                        :counter="1000"
                    />
                  </div>
                    <json-header v-if="data.step1.request" :headers="data.step1.request.headers"/>
                    <json-request :data-object="data.step1.request"/>

                </v-tab-item>
                <v-tab-item class="mt-3">
                  <div class="block-card-body">
                    <label for="">Step name</label>
                    <vTextareaAutocomplete
                        v-model="data.step2.name"
                        :type="'textfield'"
                        :validation-rules=" [v => !!v || 'Name is Required']"
                        :counter="1000"
                    />

                    <label for="">Step icon</label>
                    <image-input  :small="true" :url="data.step2.icon" @onImageUpload="data.step2.icon = $event " :validation="false" ></image-input>

                    <label for="">Step title</label>
                    <vTextareaAutocomplete
                        v-model="data.step2.title"
                        :type="'textfield'"
                        :validation-rules=" [v => !!v || 'Title is Required']"
                        :counter="1000"
                    />



                    <label for="">Save selected id to attribute</label>
                    <vTextareaAutocomplete
                        v-model="data.step2.selectedIdAttribute"
                        :type="'textfield'"
                        :validation-rules=" [v => !!v || 'Attribute is Required']"
                        :counter="1000"
                    />

                    <label for="">Save selected name to attribute</label>
                    <vTextareaAutocomplete
                        v-model="data.step2.selectedNameAttribute"
                        :type="'textfield'"
                        :validation-rules=" [v => !!v || 'Attribute is Required']"
                        :counter="1000"
                    />

                    <label for="">Save selected code to attribute</label>
                    <vTextareaAutocomplete
                        v-model="data.step2.selectedCodeAttribute"
                        :type="'textfield'"
                        :validation-rules=" [v => !!v || 'Attribute is Required']"
                        :counter="1000"
                    />

                  </div>
                  <json-header v-if="data.step2.request" :headers="data.step2.request.headers"/>
                  <json-request :data-object="data.step2.request"/>

                </v-tab-item>
                <v-tab-item class="mt-3">
                  <div class="block-card-body">
                    <label for="">Step name</label>
                    <vTextareaAutocomplete
                        v-model="data.step3.name"
                        :type="'textfield'"
                        :validation-rules=" [v => !!v || 'Name is Required']"
                        :counter="1000"
                    />

                    <label for="">Step icon</label>
                    <image-input  :small="true" :url="data.step3.icon" @onImageUpload="data.step3.icon = $event " :validation="false" ></image-input>

                    <label for="">Step title</label>
                    <vTextareaAutocomplete
                        v-model="data.step3.title"
                        :type="'textfield'"
                        :validation-rules=" [v => !!v || 'Title is Required']"
                        :counter="1000"
                    />



                    <label for="">Save date to attribute</label>
                    <vTextareaAutocomplete
                        v-model="data.step3.selectedDateAttribute"
                        :type="'textfield'"
                        :validation-rules=" [v => !!v || 'Attribute is Required']"
                        :counter="1000"
                    />

                    <label for="">Save time to attribute</label>
                    <vTextareaAutocomplete
                        v-model="data.step3.selectedTimeAttribute"
                        :type="'textfield'"
                        :validation-rules=" [v => !!v || 'Attribute is Required']"
                        :counter="1000"
                    />

                    <label for="">Save work day to attribute</label>
                    <vTextareaAutocomplete
                        v-model="data.step3.selectedWorkDayAttribute"
                        :type="'textfield'"
                        :validation-rules=" [v => !!v || 'Attribute is Required']"
                        :counter="1000"
                    />

                  </div>
                  <json-header v-if="data.step3.request" :headers="data.step3.request.headers"/>
                  <json-request :data-object="data.step3.request"/>

                </v-tab-item>
              </v-tabs>
            </div>



        </form-validation>
        <slot name = "tail" />
      </v-expansion-panel-content>
    </v-expansion-panel>
  </div>
</template>

<script>
import common from '../../../../utils/common'
import FormValidation from '../FormValidation'
import jsonHeader from './json-api/json-header'
import jsonRequest from './json-api/request'
import imageInput from './common-inner-blocks/image-uploader-dropzone'
export default {
  name: 'book-appointment',
  components: {
    FormValidation,
    jsonHeader,
    jsonRequest,
    imageInput
  },
  props: {
    data: {
      type: Object,
      default: () => {
        return {}
      }
    },
    index: {
      type: Number,
      default: () => {
        return 0
      }
    },
    blocksList: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data() {
    return {
      errorsCount: { errorsCount: 0 },
      lazyRendering: true,
      valid: true,
      panel: 1,
      common,
      autocompleteImageUrlValidationrRules: [
        v => !!v || 'Image url is required'
      ],
      activeTab: 0
    }
  },
  computed: {},
  watch: {
    errorsCount(val) {
      this.$emit('input', { errorsCount: val.errorsCount })
      this.data.errorsCount = val.errorsCount
    }
  },
  mounted() {
    if (this.data.errorsCount !== undefined) {
      this.errorsCount = this.data.errorsCount
    } else {
      // disabling Lazy rendering so we can grip errors count
      this.lazyRendering = false
      setTimeout(() => {
        // then we turn it on again to keep the performance up
        this.lazyRendering = true
      }, 1000)
    }
  },
  methods: {
    updateImageUrl(e) {
      this.data.extensionImage = e
    }
  }
}
</script>

<style >
.card-appointment .v-tabs__bar {
  margin: 0 25px;
}
</style>
